export default {
    pagination: {
        perPage: 50,
        perPageOptions: [10, 25, 50, 100, 200],
    },
};
